export default __webpack_public_path__ + "static/media/hawaii.e9b2bb4e.jpg";